import { useQuery } from "react-query";
import { authInstance } from "apis";
import Product from "types/Product";

interface Params {
  productId: number;
  option?: {
    onSuccess: (product: Product) => void;
  };
}

const useProduct = ({ productId, option }: Params) => {
  const path = `product/${productId}`;

  const fetcher = async () => {
    const { data } = await authInstance.get(path);
    return data;
  };

  const { data: product } = useQuery<Product>([path], fetcher, {
    onSuccess: (p) => {
      option?.onSuccess(p);
    },
  });

  return product;
};

export default useProduct;
